export default "__VITE_ASSET__0XY0px3k__"